import { GamesBreadcrumb } from "./index";
import { PlayGameLink } from "./index";

export default function Poker() {
  return (
    <div className="p-4 bg-white dark:bg-slate-900/80 rounded-xl shadow">
      <GamesBreadcrumb game="Texas Hold'em Poker" />
      <h1 className="text-3xl font-bold mb-4 text-slate-900 dark:text-slate-100">Texas Hold'em Poker</h1>
      <img
        src="/thumbnails/Poker.png"
        alt="Texas Hold'em Poker game screenshot"
        className="rounded-lg shadow mb-4 w-full max-w-md mx-auto bg-white dark:bg-slate-800"
      />
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">About Texas Hold'em Poker</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Texas Hold'em Poker is the world's most popular poker variant, combining strategy, skill, and a bit of luck. Players compete to make the best five-card hand using two private cards and five community cards, with rounds of betting and bluffing.
        </p>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">How to Play</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Each player is dealt two private cards (hole cards).</li>
          <li>Five community cards are dealt face up in three stages: the flop (3), the turn (1), and the river (1).</li>
          <li>Players use any combination of their hole cards and the community cards to make the best five-card hand.</li>
          <li>Betting rounds occur before the flop, after the flop, after the turn, and after the river.</li>
          <li>The player with the best hand (or the last player remaining after all others fold) wins the pot.</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Features</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Multiplayer online poker with friends or players worldwide</li>
          <li>Realistic betting, folding, and raising mechanics</li>
          <li>Hand rankings and automatic winner detection</li>
          <li>Chat and emotes for social play</li>
          <li>Customizable table settings</li>
        </ul>
      </section>
      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Tips & Tricks</h2>
        <ul className="list-disc pl-6 space-y-1 text-gray-700 dark:text-gray-300">
          <li>Pay attention to betting patterns and player behavior to spot bluffs.</li>
          <li>Be selective with starting hands—don't play every hand!</li>
          <li>Position matters: acting later in the round gives you more information.</li>
          <li>Manage your chips wisely and avoid going "all-in" too often.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2 text-slate-900 dark:text-slate-100">Play Texas Hold'em Poker</h2>
        <p className="text-gray-700 dark:text-gray-300">
          Play Texas Hold'em Poker online with friends or other players—no download or registration required. Test your skills and see if you can win the pot!
        </p>
        <PlayGameLink game="Poker" gameTitle="Texas Hold'em Poker" />
      </section>
    </div>
  );
}
